<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="inout_heading" [ttModel]="edit.inout_heading" ttReadonly></tt-input>
        <tt-datetime *ngIf="!!edit.visitor_datetime_in" ttLabel="visitor_datetime_in" [ttModel]="edit.visitor_datetime_in" ttReadonly></tt-datetime>
        <tt-datetime *ngIf="inOut === 'out' && !!edit.visitor_datetime_out" ttLabel="visitor_datetime_out" [ttModel]="edit.visitor_datetime_out" ttReadonly></tt-datetime>
        <tt-input ttLabel="pers_name" [(ttModel)]="edit.pers_name" ttRequired></tt-input>
        <tt-input ttLabel="cust_name" [(ttModel)]="edit.cust_name"></tt-input>
        <tt-input-email ttLabel="pers_email" [(ttModel)]="edit.pers_email" ttRequired></tt-input-email>
        <tt-input ttLabel="pers_jobtitle" [(ttModel)]="edit.pers_jobtitle"></tt-input>
        <tt-textarea ttLabel="visit_note" [(ttModel)]="edit.visit_note"></tt-textarea>
        <tt-button-save ttText="confirm" (ttClick)="confirmChanges()" [ttLoading]="confirming"></tt-button-save>
    </tt-card>
</tt-page>
